<template>
  <div class="container">
    <div v-for="(item, index) in items" :key="index">
      <div
        class="cicle"
        :style="
          index == active
            ? 'background-color: #321fdb'
            : 'background-color: #89ABE6;'
        "
      />
    </div>
  </div>
</template>

<script>

export default {
  name: "DotHorizontal",
  props: {
    items: Number,
    active: Number,
  },
  data() {
    return {};
  },
  methods: {},
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  beforeDestroy() {},
};
</script>

<style scoped>
.container {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
}
.cicle {
  width: 10px;
  height: 10px;
  border-radius: 100px;
  background-color: #89abe6;
  margin: 0 10px;
}
</style>